import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

/* ============================ İKON YAZI TİPİ ================================
 *
 * Font Awesome uygulamanın her yerinde kullanılıyor (menüler, panel düğmeleri,
 * kartlar, maç ekranları — 170'e yakın kullanım) ama paket bir bağımlılık olarak
 * durduğu hâlde CSS'i hiçbir yerden import edilmiyordu. Sonuç: derlenmiş çıktıda
 * tek bir .fa- sınıf tanımı ve tek bir webfont dosyası yoktu, bütün
 * <i class="fa-solid ..."> öğeleri boş çiziliyordu.
 *
 * Neden "all.min.css" değil: all.min.css markalar (brands) ailesini de getiriyor
 * ve onunla birlikte 116 KB'lık fa-brands-400.woff2 pakete giriyor. Uygulamada
 * hiç fa-brands kullanımı yok, bu yüzden yalnızca gerçekten kullanılan aileler
 * alınıyor:
 *   fontawesome -> temel kurallar + ikon tanımları (zorunlu)
 *   solid       -> fa-solid  (uygulamada baskın kullanım)
 *   regular     -> fa-regular
 * Yeni bir ailenin (ör. fa-brands) ilk kullanımında ilgili satır buraya eklenmeli;
 * aksi halde o ikonlar yine boş çizilir.
 *
 * Uygulama stillerinden ÖNCE import ediliyor ki çakışmalarda uygulamanın kendi
 * kuralları kazansın.
 * ========================================================================== */
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "@fortawesome/fontawesome-free/css/solid.min.css";
import "@fortawesome/fontawesome-free/css/regular.min.css";

// Doğrudan axios kullanan eski editör ekranlarına oturum bilgisini ekler.
// Uygulama kodundan ÖNCE yüklenmeli ki ilk istekler de jetonu taşısın.
import "./api/legacyAxiosAuth";

import App from "./App";
// Kökteki yakalanmamış çizim hataları beyaz ekran yerine yenileme ekranı gösterir.
import RootErrorBoundary from "./components/RootErrorBoundary";

// (Varsa sağlayıcılarınızı burada kullanın)
// import { ScopeProvider } from "./state/ScopeContext";
// import { DataProvider } from "./pages/Cache"; // örnek

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <RootErrorBoundary>
      {/* <ScopeProvider> */}
      {/* <DataProvider> */}
      <BrowserRouter>
        <App />
      </BrowserRouter>
      {/* </DataProvider> */}
      {/* </ScopeProvider> */}
    </RootErrorBoundary>
  </React.StrictMode>
);
